import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ProductCard } from './ProductCard';
const products = [{
  id: 25,
  name: 'Fila Cap - Gold',
  price: '$60.00',
  image: 'https://cdn.magicpatterns.com/uploads/1NAtNJ2fcku1izttueGKgP/pasted-image.jpg'
}, {
  id: 26,
  name: 'Trilyn Bag Set',
  price: '$100.00',
  image: 'https://cdn.magicpatterns.com/uploads/iMXocAq8RByxdFHyhLJkKz/pasted-image.jpg'
}, {
  id: 1,
  name: 'Royal Kente Wrap Dress',
  price: '$210.00',
  image: 'https://images.unsplash.com/photo-1548036328-c9fa89d128fa?q=80&w=2069&auto=format&fit=crop'
}, {
  id: 2,
  name: 'Golden Sun Earrings',
  price: '$85.00',
  image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?q=80&w=1974&auto=format&fit=crop'
}, {
  id: 3,
  name: 'Zarrito Patterned Kaftan',
  price: '$145.00',
  image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 4,
  name: 'Heritage Beaded Necklace',
  price: '$120.00',
  image: 'https://images.unsplash.com/photo-1589156280159-27698a70f29e?q=80&w=1972&auto=format&fit=crop'
}, {
  id: 5,
  name: 'Victoria Silk Scarf',
  price: '$65.00',
  image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?q=80&w=2070&auto=format&fit=crop'
}, {
  id: 6,
  name: 'Tribal Print Clutch',
  price: '$95.00',
  image: 'https://images.unsplash.com/photo-1532332248682-206cc786359f?q=80&w=1978&auto=format&fit=crop'
}];
export function NewArrivals() {
  return <section className="py-20 bg-gray-50" data-id="element-256">
      <div className="container mx-auto px-4" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row justify-between items-center md:items-end mb-12 text-center md:text-left" data-id="element-258">
          <div className="flex flex-col items-center md:items-start" data-id="element-259">
            <h2 className="text-3xl md:text-5xl font-serif mb-4 uppercase tracking-widest leading-tight" data-id="element-260">
              New Arrivals
            </h2>
            <div className="w-24 h-1 bg-gold" data-id="element-261"></div>
          </div>
          <Link to="/shop" className="hidden md:block text-xs uppercase tracking-widest font-bold border-b border-black pb-1 hover:text-gold hover:border-gold transition-all self-center" data-id="element-262">
            View All Arrivals
          </Link>
        </motion.div>

        {/* Infinite Slider */}
        <div className="relative overflow-hidden py-4" data-id="element-263">
          <motion.div className="flex gap-6 md:gap-10" animate={{
          x: [0, '-50%']
        }} transition={{
          x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: 75,
            ease: 'linear'
          }
        }} style={{
          width: 'max-content'
        }} data-id="element-264">
            {/* Double the products for infinite loop effect */}
            {[...products, ...products].map((product, index) => <div key={`${product.id}-${index}`} className="w-[280px] md:w-[350px] flex-shrink-0" data-id="element-265">
                <ProductCard product={{
              ...product,
              collection: index % 2 === 0 ? 'New Arrival' : 'TriLyn',
              rating: 5
            }} data-id="element-266" />
              </div>)}
          </motion.div>
        </div>

        <div className="mt-5 text-center" data-id="element-267">
          <Link to="/shop" className="text-xs uppercase tracking-widest font-bold border-b border-black pb-1 hover:text-gold hover:border-gold transition-all" data-id="element-268">
            View All Arrivals
          </Link>
        </div>
      </div>
    </section>;
}